<template>
    <v-card :loading="loading" width="450">
        <v-card-title>
            <TitleOfDialog title="Add Mission" @close="emit('close')"></TitleOfDialog>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
            <v-card-subtitle class="text-wrap mb-3">You are adding a vehicle to this mission. To add a vehicle to the
                system,
                you
                need to go to the
                Vehicles section.
            </v-card-subtitle>
            <v-form ref="missionForm">
                <v-select color="primary" label="Vehicle" :rules="[v => !!v || 'Vehicle is required']"
                    v-model="vehicleToAdd" required :items="possibleVehicles" item-value="id" item-title="name">
                </v-select>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="validate()" class="w-100" color="primary" variant="elevated" text="Add vehicle"></v-btn>
        </v-card-actions>
    </v-card>

</template>


<script setup>
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import { onMounted, ref } from 'vue';
import { useVehicleStore } from '@/store/vehicleStore';
import { storeToRefs } from 'pinia';

const vehicleStore = useVehicleStore();
const { possibleVehicles } = storeToRefs(vehicleStore);
const loading = ref(false);
const emit = defineEmits(['close'])
const props = defineProps(['mission']);
const missionForm = ref();
const vehicleToAdd = ref();

onMounted(() => {
    loading.value = true;
    vehicleStore.fetchPossibleVehicles(props.mission.id);
    loading.value = false;
})


const validate = async () => {
    const isValid = await missionForm.value?.validate();
    if (isValid.valid) {
        loading.value = true;
        try {
            await vehicleStore.assingVehicle(vehicleToAdd.value, props.mission.id);
            loading.value = false;
            emit('close');
        } catch (error) {
            loading.value = false;
            console.error("Error en la validación o creación de la mision:", error);
        }
    } else {
        console.log("Formulario no válido:", isValid);
    }
}
</script>